import type { ElectricalSlots } from "building-types/electrical/electricalSlots";
import { ControllerType, LoadType } from "building-types/electrical/electricalTypesEnum";
import type { ElectricalSettings } from "building-types/settings/electricalSettings";
import { SettingsType } from "building-types/settings/settingsType";

const defaultElectricalSlots: ElectricalSlots = {
  controllers: {
    primary: ControllerType.SWITCH,
    sensor: ControllerType.SENSOR,
  },
  loads: {
    primaryLight: LoadType.MOUNTED_CEILING_LIGHT,
    secondaryLight: LoadType.RECESSED_CEILING_LIGHT,

    outlet: LoadType.OUTLET,
    outletGFCI: LoadType.OUTLET_GFCI,
    outletHDMI: LoadType.OUTLET_HDMI,

    recessedCeilingLight: LoadType.RECESSED_CEILING_LIGHT,

    pendantCeilingLight: LoadType.PENDANT_CEILING_LIGHT,
    keylessCeilingLight: LoadType.KEYLESS_CEILING_LIGHT,

    flourescentCeilingLight: LoadType.FLOURESCENT_CEILING_LIGHT,

    trackCeilingLight: LoadType.TRACK_CEILING_LIGHT,

    mountedWallLight: LoadType.MOUNTED_WALL_LIGHT,

    fanCeiling: LoadType.CEILING_FAN,

    smokeDetector: LoadType.SMOKE_DETECTOR,

    carbonMonoxideDetector: LoadType.CARBON_MONOXIDE_DETECTOR,

    thermostat: LoadType.THERMOSTAT,

    bathFan: LoadType.BATH_FAN,

    cableOutlet: LoadType.CABLE_OUTLET,
    floodLight: LoadType.FLOOD_LIGHT,

    outletGFCIwaterProof: LoadType.OUTLET_GFCI_WP,
    outletFloor: LoadType.OUTLET_FLOOR,

    garageDoorOpener: LoadType.GARAGE_DOOR_OPENER,

    dishDisposal: LoadType.DISH_DISPOSAL,

    doorbellChime: LoadType.DOORBELL_CHIME,

    outlet240V: LoadType.OUTLET_240V,
    outlet220V: LoadType.OUTLET_220V,
    outletCAT5: LoadType.OUTLET_CAT5,

    hoseBib: LoadType.HOSE_BIB,
  },
};

export const defaultElectricalSettings: ElectricalSettings = {
  type: SettingsType.ELECTRICAL_SETTINGS,
  slots: defaultElectricalSlots,
  rules: {},
};
